import { IconNumber3, IconNumber1, IconNumber2 } from '@tabler/icons-react';
import { Card, Container, Group, SimpleGrid, Text, Title, Image, ThemeIcon } from '@mantine/core';
import classes from './FeaturesCards.module.css';

import PhoneImg from '../../imgs/smartphone.jpg';
import MailImg from '../../imgs/call.jpg';
import ApproveImg from '../../imgs/man-woman-loan.jpg';

const mockdata = [
  {
    id: '1',
    title: 'Contacta con nosotros',
    description:
      'Envíanos un mensaje o llámanos para comenzar tu trámite. Solo necesitas tener un auto con factura, en buenas condiciones y con menos de 10 años de antigüedad.',
    icon: IconNumber1,
    img: PhoneImg,
  },
  {
    id: '2',
    title: 'Ten la respuesta al instante',
    description:
      'Nuestro equipo revisará tu información y te dará una respuesta en menos de 24 horas hábiles. Te explicaremos las condiciones de forma clara y sin letras pequeñas.',
    icon: IconNumber2,
    img: MailImg,
  },
  {
    id: '3',
    title: 'Obtén tu préstamo',
    description:
      'Una vez aprobado, recibirás el dinero directamente en tu cuenta bancaria. ¡Así de fácil!',
    icon: IconNumber3,
    img: ApproveImg,
  },
];

export function FeaturesCards() {
  const features = mockdata.map((feature) => (
    <Card key={feature.title} shadow="md" radius="md" className={classes.card} padding="xl">
      <Card.Section>
        <Image src={feature.img} height={170} alt={feature.title} fit="cover" loading="lazy" />
      </Card.Section>
      <Group mt="md" mb={5}>
        <ThemeIcon size={40} radius="md" variant="light" className={classes.icon}>
          <feature.icon size={24} stroke={1.5} />
        </ThemeIcon>

        <Text fz="lg" fw={500} className={classes.cardTitle} mt="md">
          {feature.title}
        </Text>
      </Group>

      <Text fz="sm" mt="sm" className={classes.decriptionCard}>
        {feature.description}
      </Text>
    </Card>
  ));

  return (
    <Container component={'section'} className={classes.wrapper} size="lg" py="xl" id="como-funciona">
      <Container className={classes.introContainer}>
        <Title order={2} className={classes.title} ta="center" mt="sm">
          ¿Cómo funciona UNO&UNO?
        </Title>

        <Text c="dimmed" className={classes.description} ta="center" mt="md">
          Solicitar un préstamo nunca fue tan fácil. Nuestro proceso está diseñado para ser rápido,
          transparente y sin complicaciones. En solo tres simples pasos, podrás obtener el dinero
          que necesitas de manera segura.
        </Text>
      </Container>

      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg" mt={0} className={classes.grid}>
        {features}
      </SimpleGrid>
    </Container>
  );
}
